import { useContext } from 'react';
import { AdminPanelThemeContext } from './AdminPanelThemeContext';
import { useStorePanelTheme } from './useStorePanelTheme';

/** Theme mode from admin shell (if wrapped) or store page hook — same localStorage key. */
export function usePanelThemeMode() {
  const adminCtx = useContext(AdminPanelThemeContext);
  const store = useStorePanelTheme();
  if (adminCtx) return adminCtx.mode;
  return store.mode;
}
